/* eslint-disable import/prefer-default-export */
export const MESSAGES = {
  canEmailAllowed: {
    firstEmail: [
      {
        text: 'A welcome email will go to <name> asking for their communication preferences.',
      },
      {
        text: 'Once they verify this email belongs to them, they can use it to log in to the community.',
      },
      {
        text: 'All email communication from you will now go to this primary email.',
      },
    ],
    notFirstEmail: {
      notify: [
        {
          text: 'The emails currently on <name>’s record will be notified to verify if this new email belongs to them and to update their preferences.',
        },
        {
          text: 'Once they verify this email belongs to them, they can use it to log in to the community.',
        },
      ],
      doNotNotify: {
        primary: [
          {
            text: 'You are verifying that this email belongs to <name>, and they will not be notified.',
          },
          {
            text: 'Anybody with access to <email> can login to the community as <name>.',
          },
          {
            text: 'They will also start receiving email communication from you on <email> instead of <old_email>',
          },
        ],
        nonPrimary: [
          {
            text: 'You are verifying that this email belongs to <name>, and they will not be notified.',
          },
          {
            text: 'Anybody with access to <email> can login to the community as <name>.',
          },
          {
            text: 'They will continue to receive email communication from you on <old_email> which is their primary email.',
          },
        ],
      },
    },
  },
  canEmailDenied: {
    firstEmail: [
      {
        text: 'A welcome email will go to <name> asking for their communication preferences.',
      },
      {
        text: 'Once they verify this email belongs to them, they can use it to log in to the community.',
      },
      {
        text: 'The record is currently opted out of email communication. No email communication from you will go to them unless they update this choice.',
      },
    ],
    notFirstEmail: {
      notify: [
        {
          text: 'The emails currently on <name>’s record will be notified to verify if this new email belongs to them and to update their preferences.',
        },
        {
          text: 'Once they verify this email belongs to them, they can use it to log in to the community.',
        },
      ],
      doNotNotify: {
        primary: [
          {
            text: 'You are verifying that this email belongs to <name>, and they will not be notified.',
          },
          {
            text: 'Anybody with access to <email> can login to the community as <name>.',
          },
          {
            text: 'The record is currently opted out of email communication. No communication from you will go to them unless they log in to update this choice.',
          },
        ],
        nonPrimary: [
          {
            text: 'You are verifying that this email belongs to <name>, and they will not be notified.',
          },
          {
            text: 'Anybody with access to <email> can login to the community as <name>.',
          },
          {
            text: 'The record is currently opted out of email communication. No communication from you will go to them unless they log in to update this choice.',
          },
        ],
      },
    },
  },
};
